import React from 'react';
import { CheckCircle2Icon, MessageCircleIcon, AlertTriangleIcon } from 'lucide-react';
import { Button, ButtonAnchor } from '../ui/Button';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../../utils/vehicles';
export function FormCard({
  title,
  lead,
  children
}: {
  title: string;
  lead?: string;
  children: React.ReactNode;
}) {
  return <div className="rounded-2xl border border-line bg-surface2/40 p-6 md:p-8" data-id="element-150" data-mp="3ktswqn2phunb">
      <h3 className="text-xl font-bold text-white md:text-2xl" data-id="element-151" data-mp="m9ja6p3dp7sd">{title}</h3>
      {lead ? <p className="mt-2 text-sm leading-relaxed text-mist" data-id="element-152" data-mp="hcanqcb76hlb">{lead}</p> : null}
      <div className="mt-6" data-id="element-153" data-mp="cjpzdqb28wp6">{children}</div>
    </div>;
}
export function FormSuccess({
  message,
  reference
}: {
  message: string;
  reference?: string;
}) {
  return <div role="status" className="rounded-2xl border border-emerald-400/30 bg-emerald-400/[0.07] p-6 text-center md:p-8" data-id="element-154" data-mp="150k61497cn7p">
      <CheckCircle2Icon className="mx-auto h-10 w-10 text-emerald-400" aria-hidden="true" data-id="element-155" data-mp="108smvesdljrl" />
      <p className="mt-4 text-lg font-semibold text-white" data-id="element-156" data-mp="1gun6ocbpxikk">{message}</p>
      {reference ? <p className="mt-2 text-sm text-mist" data-id="element-157" data-mp="1kuf8m66lwqgy">
          Número de registro:{' '}
          <span className="font-semibold text-white" data-id="element-158" data-mp="17390jlp9hkig">{reference}</span>
        </p> : null}
      <ButtonAnchor href={whatsappLink(GENERAL_WA_MESSAGE)} variant="whatsapp" size="md" className="mt-6" data-id="element-159" data-mp="1c2llu20hijix">
        <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-160" data-mp="x88rmuf7g0el" />
        Hablar con un vendedor ahora
      </ButtonAnchor>
    </div>;
}
export function FormError({
  onRetry
}: {
  onRetry: () => void;
}) {
  return <div role="alert" className="mb-5 rounded-xl border border-amber-400/35 bg-amber-400/[0.07] p-4" data-id="element-161" data-mp="t4j50ai3bsw7">
      <p className="flex items-start gap-2.5 text-sm font-semibold text-amber-200" data-id="element-162" data-mp="2iixpujpzmvmf">
        <AlertTriangleIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-163" data-mp="2nia9ywph5olb" />
        No pudimos enviar tu consulta. Por favor intentá nuevamente o escribinos por
        WhatsApp.
      </p>
      <div className="mt-4 flex flex-wrap gap-2.5" data-id="element-164" data-mp="2h2bk5x1tif66">
        <Button variant="outline" size="sm" onClick={onRetry} data-id="element-165" data-mp="2h0qmvzo4ci4m">
          Reintentar envío
        </Button>
        <ButtonAnchor href={whatsappLink(GENERAL_WA_MESSAGE)} variant="whatsapp" size="sm" data-id="element-166" data-mp="2c3h0ksw10ml0">
          <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-167" data-mp="34rwch6jv2os4" />
          Escribir por WhatsApp
        </ButtonAnchor>
      </div>
    </div>;
}
export function FormFooterNote({
  children
}: {
  children: React.ReactNode;
}) {
  return <p className="mt-4 text-[12.5px] leading-relaxed text-mist" data-id="element-168" data-mp="2v1b8t4pbyu2c">{children}</p>;
}